import Home from '../views/Home';
// import SearchJobItem from '../components/SearchJob/SearchJobItem';
import RecruitingServicesBase from '../views/PublicPagesBase/RecruitingServicesBase';
import RecruitingServicesBaseNew from '../views/PublicPagesBase/RecruitingServicesBaseNew';
import FreeJobPostingBase from '../views/PublicPagesBase/FreeJobPostingBase';
import SearchJobBase from '../views/PublicPagesBase/SearchJobBase';
import Freelancers from '../views/PublicPagesBase/FreeLancersView';
import TermsAndConditions from '../views/PublicPagesBase/Terms';
import JobPortalItem from '../views/JobPortalItem';
import IntegrityBase from '../views/PublicPagesBase/PrivacyPolicyBase';
import SharkMan from '../views/PublicPagesBase/SharkMan';
// import ResetPassword from '../views/Home';
import EmployersLandingPage from '../views/PublicPagesBase/EmployersLandingPage';
import PlantATree from '../views/PublicPagesBase/PlantATree';
import ClientsLandingPage from '../views/PublicPagesBase/ClientsLandingPage';
import CandidatesLandingPage from '../views/PublicPagesBase/CandidatesLandingPage';

import EmptyRouterView from '../router/EmptyRouterView';

const url_prefix = process.env.VUE_APP_URL_PREFIX;

export default [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Auth/Login.vue'),
    meta: {
      requiresAuth: false,
      adminAuth: false,
    },
  },
  {
    path: '/sign-up-candidates',
    name: 'register-candidate',
    component: () => import('../views/Auth/RegisterCandidate.vue'),
    meta: {
      requiresAuth: false,
      adminAuth: false,
    },
  },
  {
    path: '/sign-up-employers',
    name: 'register-employers',
    component: () => import('../views/Auth/RegisterEmployer.vue'),
    meta: {
      requiresAuth: false,
      adminAuth: false,
    },
  },
  {
    path: '/user-conditions-employers',
    name: 'new-conditions',
    component: () => import('../views/PublicPagesBase/NewConditions.vue'),
    meta: {
      requiresAuth: false,
      adminAuth: false,
    },
  },
  {
    path: '/integrity',
    name: 'integrity',
    component: () => import('../views/PublicPagesBase/Integrity.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/cookies',
    name: 'cookies',
    component: () => import('../views/PublicPagesBase/Cookies.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  /*   {
    path: '/search-jobs',
    name: 'search-jobs',
    component: SearchJobBase,
    meta: {
      requiresAuth: false,
    },
  }, */
  /* {
    path: url_prefix + '/public/jobad/:jobad_id',
    name: 'preview-job-ad',
    component: JobPortalItem,
    meta: {
      requiresAuth: false,
      adminAuth: false,
      recruiterAuth: false,
    },
  }, */
  /*   {
    path: '/search-jobs/:slug',
    name: 'preview-job-ad',
    component: JobPortalItem,
    meta: {
      requiresAuth: false,
      adminAuth: false,
      recruiterAuth: false,
    },
  }, */
  /*   {
    path: '/free-job-posting',
    name: 'job-posting',
    component: FreeJobPostingBase,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/freelancers',
    name: 'freelancers',
    component: Freelancers,
    meta: {
      requiresAuth: false,
    },
  }, */
  /*   {
    path: '/recruiting-services',
    name: 'recruiting-services',
    component: RecruitingServicesBase,
    meta: {
      requiresAuth: false,
    },
  }, */
  /*   {
    path: '/recruiting-services',
    name: 'recruiting-services',
    redirect: '/tech-recruiting',
    component: RecruitingServicesBaseNew,
    meta: {
      requiresAuth: false,
    },
  }, */
  /*   {
    path: '/tech-recruiting',
    name: 'tech-recruiting',
    component: RecruitingServicesBaseNew,
    meta: {
      requiresAuth: false,
    },
  }, */

  /*   {
    path: '/employers',
    name: 'employers',
    component: TermsAndConditions,
    meta: {
      requiresAuth: false,
    },
  }, */
  {
    path: '/reset-password',
    name: 'reset-password',
    meta: {
      requiresAuth: false,
    },
    component: () => import('../views/ResetPassword'),
  },
  {
    path: '/reset-password-employer',
    name: 'reset-password-employer',
    meta: {
      requiresAuth: false,
    },
    component: () => import('../views/ResetPasswordEmployer'),
  },
  {
    path: '/reset-password-candidate',
    name: 'reset-password-candidate',
    meta: {
      requiresAuth: false,
    },
    component: () => import('../views/ResetPasswordCandidate'),
  },
  /*   {
    path: '/tech-recruitment',
    name: 'tech-recruitment',
    component: EmployersLandingPage,
    meta: {
      requiresAuth: false,
    },
  }, */
  /*   {
    path: '/plant-a-tree',
    name: 'plant-a-tree',
    component: PlantATree,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/new-jobshark',
    name: 'new-jobshark',
    component: ClientsLandingPage,
    meta: {
      requiresAuth: false,
    },
  }, */
  /*   {
    path: '/tech-jobs',
    name: 'tech-jobs',
    component: CandidatesLandingPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: url_prefix + '/public/sharkman',
    name: 'SharkMan',
    component: SharkMan,
    meta: {
      requiresAuth: false,
    },
  }, */
  /*   {
    path: '/about-us',
    name: 'about-us',
    meta: {
      requiresAuth: false,
    },
    component: () => import('../views/AboutBase/About'),
  },
  {
    path: '/contact',
    name: 'contact',
    meta: {
      requiresAuth: false,
    },
    component: () => import('../views/PublicPagesBase/ContactBase'),
  }, */
  /*   {
    path: '/success',
    name: 'linkedin-success',
    meta: {
      requiresAuth: false,
    },
    component: () => import('../views/LinkedInSuccess'),
  },
  {
    path: '/cancelled',
    name: 'linkedin-cancelled',
    meta: {
      requiresAuth: false,
    },
    component: () => import('../views/LinkedInCancelled'),
  },
  {
    path: url_prefix + '/public/company',
    name: 'company-preview',
    meta: {
      requiresAuth: false,
    },
    component: () => import('../views/PublicPagesBase/CompanyPreview'),
  }, */
];
